import { graphql, Link, useScrollRestoration, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useState } from "react"
import ImageOpt from "./../ImageOpt"

function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = React.useState(null)

  React.useEffect(() => {
    let lastScrollY = window.pageYOffset

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset
      const direction = scrollY > lastScrollY ? "down" : "up"
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 1 || scrollY - lastScrollY < -1)
      ) {
        setScrollDirection(direction)
      }
      lastScrollY = scrollY > 0 ? scrollY : 0
    }
    window.addEventListener("scroll", updateScrollDirection) // add event listener

    return () => {
      window.removeEventListener("scroll", updateScrollDirection) // clean up
    }
  }, [scrollDirection])

  return scrollDirection
}

const Banner = ({ module, siteName, location }) => {
  const sitesData = useStaticQuery(graphql`
    query {
      wp {
        fluxDnaSettings {
          fluxDna {
            microsite {
              selectSite
              bannerImage {
                altText
                mediaItemUrl
              }
              bannerImageMobile {
                altText
                mediaItemUrl
              }
              logo {
                altText
                mediaItemUrl
              }
              menuLogo {
                altText
                mediaItemUrl
              }
              micrositeButton {
                target
                title
                url
              }
              subMenu {
                menuItem {
                  target
                  title
                  url
                }
              }
            }
          }
        }
      }
    }
  `)
  const sitesDataList = sitesData.wp.fluxDnaSettings.fluxDna
  const selectMicrosite = siteName

  const filteredData = sitesDataList.microsite.filter(
    item => item.selectSite === selectMicrosite
  )

  const [scrollPosition, setScrollPosition] = useState(
    location.state?.prevScrollPosition ? location.state.prevScrollPosition : 0
  )

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scroll(0, location.state?.prevScrollPosition)
    }
  }, [])

  useEffect(() => {}, [scrollPosition])

  const handleScroll = event => {
    const position = window.pageYOffset
    setScrollPosition(position)
  }

  useEffect(() => {
    window.addEventListener("wheel", handleScroll)
    return () => {
      window.removeEventListener("wheel", handleScroll)
    }
  }, [])

  const scrollDirection = useScrollDirection()
  const [stickyClass, setStickyClass] = useState("")
  useEffect(() => {
    const handleScroll = () => {
      if (filteredData.length > 0) {
        const secondSection = document.getElementById("menuSticky")
        const secondSectionOffset = secondSection.offsetTop
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop

        if (scrollTop >= secondSectionOffset && window.pageYOffset > 552) {
          setStickyClass(true)
        } else {
          setStickyClass(false)
        }
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [filteredData.length])

  const [labelleBtnHover, setLabelleBtnHover] = useState(false)

  const onMouseEnter = () => {
    setLabelleBtnHover(true)
  }

  const onMouseLeave = () => {
    setLabelleBtnHover(false)
  }

  const [toggle, setToggle] = useState(false)
  if (module.hideSection === "no") {
    if (filteredData.length > 0) {
      return (
        <>
          <div
            className={`microbanner banner half-banner mdscreen:h-[457px] relative pt-85 ${
              module.extraClass ? `${module.extraClass}` : ""
            }`}
            id={module.extraId}
          >
            <div className="container-fluid h-full">
              {filteredData.map((item, i) => (
                <div className="banner-inner relative h-full" key={i}>
                  {item?.bannerImage && (
                    <div className="desk-img h-full mdscreen:h-full relative block mdscreen:hidden">
                      <ImageOpt
                        imgData={item.bannerImage.mediaItemUrl}
                        width={1440}
                        height={829}
                        imgAlt={item.bannerImage.altText}
                        imgLoad="eager"
                        imgClass="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  {item?.bannerImageMobile && (
                    <div className="mobile-img h-full relative hidden mdscreen:block">
                      <ImageOpt
                        imgData={item.bannerImageMobile.mediaItemUrl}
                        width={1440}
                        height={829}
                        imgAlt={item.bannerImageMobile.altText}
                        imgLoad="eager"
                        imgClass="w-full h-full object-cover"
                      />
                    </div>
                  )}
                  {item?.logo && (
                    <div className="banner-content absolute top-50per left-50per translate-y-minus_50 translate-x-minus_50 z-10">
                      <img
                        src={item.logo.mediaItemUrl}
                        width={461}
                        height={81}
                        loading="eager"
                        alt={item.logo.altText}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          {filteredData.map((item, j) => (
            <div className="container-fluid micro-topnav" key={j}>
              <div
                id="menuSticky"
                className={`${
                  stickyClass
                    ? "lgscreen:fixed top-0 w-full smscreen2:w-full z-9 transition-all duration-[750ms] ease-in-out"
                    : ""
                } ${
                  scrollDirection === "up"
                    ? " lgscreen:top-[88px] transition-all duration-[750ms] ease-in-out"
                    : ""
                } transition-all duration-[750ms] ease-in-out topnavbar bgBaptiste px-80 xlscreen:px-40 py-15 lgscreen:px-30`}
                key={j}
              >
                <div className="flex flex-wrap items-center justify-between">
                  {item?.menuLogo && (
                    <div className="logo">
                      <Link
                        to={
                          item.subMenu[0] ? item.subMenu[0].menuItem.url : "/"
                        }
                      >
                        <img
                          src={item.menuLogo.mediaItemUrl}
                          className="mdscreen:h-[30px] mdscreen:object-contain"
                          width={196}
                          height={71}
                          loading="eager"
                          alt={item.menuLogo.altText}
                        />
                      </Link>
                    </div>
                  )}
                  <ul className="flex flex-wrap justify-center gap-x-4 xlscreen:gap-x-2 gap-y-5 lgscreen:hidden">
                    {item.subMenu &&
                      item.subMenu.map((m_iteam, k) => (
                        <li key={k}>
                          {m_iteam?.menuItem && (
                            <Link
                              to={m_iteam.menuItem.url}
                              state={{ prevScrollPosition: scrollPosition }}
                              target={m_iteam.menuItem.target}
                              className="text-18 xlscreen:text-16 tracking-05em uppercase relative"
                            >
                              <span>{parse(m_iteam.menuItem.title)}</span>
                            </Link>
                          )}
                        </li>
                      ))}
                  </ul>
                  {item.micrositeButton &&
                    location.pathname.includes("boutique-marly") !== true &&
                    location.pathname.includes("la-belle") !== true && (
                      <div className="lgscreen:hidden">
                        <Link
                          to={item.micrositeButton.url}
                          target={item.micrositeButton.target}
                          className="btn btn-black"
                        >
                          {item.micrositeButton.title}
                        </Link>
                      </div>
                    )}
                  {item.micrositeButton &&
                    location.pathname.includes("la-belle") === true && (
                      <div
                        className="laBelleBtn"
                        onMouseEnter={onMouseEnter}
                        onMouseLeave={onMouseLeave}
                      >
                        <span className="btn bg-white-100 text-labelle border-1 border-white-100 hover:cursor-pointer hover:bg-labelle hover:text-white-100 lgscreen:hidden">
                          {item.micrositeButton.title}
                        </span>
                        {labelleBtnHover && (
                          <div
                            className={`laBelleDropdown pb-[30px] bg-labelle absolute z-[9] top-[615px] right-[30px] lgscreen:hidden flex flex-row gap-[30px] pt-[30px] transition-all delay-[10ms] duration-150 ease-out`}
                          >
                            <div class="border-1 border-[#fff] rounded-2 py-45 text-center ml-[30px]">
                              <div class="px-20">
                                <a
                                  target="_blank"
                                  class="btn btn-black"
                                  href="https://account.dineplan.com/widgetframe/B8dT2xLg?source=Website"
                                >
                                  Book Camps Bay
                                </a>
                              </div>
                            </div>
                            <div class="border-1 border-[#fff] rounded-2 py-45 text-center mr-[30px]">
                              <div class="px-20">
                                <a
                                  target="_blank"
                                  class="btn btn-black"
                                  href="https://account.dineplan.com/widgetframe/vTZxJFVW?source=Website"
                                >
                                  Book Constantia
                                </a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  {location.pathname.includes("boutique-marly") === true && (
                    <div className="lgscreen:hidden w-[134px]"></div>
                  )}
                  <div className="mobileNavbar relative hidden lgscreen:block">
                    <button
                      onClick={() => setToggle(!toggle)}
                      className="flex flex-wrap gap-x-4 outline-none"
                    >
                      <span className="text-17 tracking-05em">MENU</span>
                      {item?.menuLogo && (
                        <img
                          src="../../../images/mobile-menu.svg"
                          width={7}
                          height={21}
                          loading="lazy"
                          alt={item.menuLogo.altText}
                        />
                      )}
                    </button>

                    <ul
                      className={`tabs bgBaptiste absolute top-55 -right-10 z-9 ${
                        toggle ? "open" : ""
                      }`}
                    >
                      {item.subMenu.length > 0 &&
                        item.subMenu.map((m_iteam, k) => {
                          return (
                            <li key={k}>
                              {m_iteam?.menuItem && (
                                <Link
                                  to={m_iteam.menuItem.url}
                                  target={m_iteam.menuItem.target}
                                  className="text-18 xlscreen:text-16 tracking-05em uppercase"
                                >
                                  {parse(m_iteam.menuItem.title)}
                                </Link>
                              )}
                            </li>
                          )
                        })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      )
    }
  }
  return null
}

export default Banner
export const EatDrinkBannerFragment = graphql`
  fragment EatDrinkBannerFragment on WpEatDrink_Restaurantcontent_RestaurantContent_Banner {
    extraId
    extraClass
    hideSection
  }
`
